import React from "react";
import { Alert, Group, Text, CopyButton, ActionIcon } from "@mantine/core";
import {
  IconAlertHexagon,
  IconArrowBigRightLineFilled,
  IconArrowBigLeftLineFilled,
  IconReceiptBitcoin,
  IconCheck,
  IconCopy,
  IconSend2,
  IconCoinBitcoinFilled,
  IconHourglass,
} from "@tabler/icons-react";
import { BobEvent } from "../../stores/BobEvent";
import { formatDistanceToNow } from "date-fns";

export const EventAlert = ({ event }: { event: BobEvent }) => {
  let iconElement;

  switch (event.kind) {
    case "payattempt-started":
      iconElement = <IconArrowBigRightLineFilled />;
      break;
    case "payattempt-succeeded":
      iconElement = <IconSend2 />;
      break;
    case "invoice-paid":
      iconElement = <IconCheck />;
      break;
    case "invoice-created":
      iconElement = <IconReceiptBitcoin />;
      break;
    case "onchain-address-created":
      iconElement = <IconCoinBitcoinFilled />;
      break;
    case "onchain-payment-sent":
      iconElement = <IconArrowBigRightLineFilled />;
      break;
    case "onchain-payment-received":
      iconElement = <IconArrowBigLeftLineFilled />;
      break;
    case "hold-invoice-accepted":
      iconElement = <IconHourglass />;
      break;
    case "platform-alert":
    default:
      iconElement = <IconAlertHexagon />;
      break;
  }

  const truncatedPayReq =
    event.payRequest && event.payRequest.length > 20
      ? `${event.payRequest.slice(0, 20)}…`
      : event.payRequest;

  return (
    <Alert variant="light" color="blue" title={event.title} icon={iconElement}>
      {event.message}
      {event.payRequest && (
        <Group mt="xs" gap="xs">
          <Text size="sm" c="dimmed" style={{ wordBreak: "break-all" }}>
            {truncatedPayReq}
          </Text>
          <CopyButton value={event.payRequest}>
            {({ copied, copy }) => (
              <ActionIcon
                size="sm"
                variant={copied ? "filled" : "default"}
                color={copied ? "teal" : "blue"}
                onClick={copy}
                aria-label="copy pay request"
              >
                {copied ? (
                  <IconCheck style={{ width: 14, height: 14 }} />
                ) : (
                  <IconCopy style={{ width: 14, height: 14 }} />
                )}
              </ActionIcon>
            )}
          </CopyButton>
        </Group>
      )}
      <Text mt="xs" size="sm" c="dimmed">
        {formatDistanceToNow(new Date(event.createdAtTimestamp), {
          addSuffix: true,
        })}
      </Text>
    </Alert>
  );
};
